import * as UpdatePhysicalPersonTypes from 'src/actions/physical-person/update/Types';
import { UpdatePhysicalPersonAction } from 'src/actions/physical-person/update/UpdatePhysicalPerson.actions';

export interface UpdatePhysicalPersonState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: UpdatePhysicalPersonState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function UpdatePhysicalPersonReducer(state: UpdatePhysicalPersonState = initialState,
                                            action: UpdatePhysicalPersonAction): UpdatePhysicalPersonState {
  switch (action.type) {
    case UpdatePhysicalPersonTypes.UPDATE_PHYSICAL_PERSON_ATTEMPT:
      return {...state, loading: true, error: false};
    case UpdatePhysicalPersonTypes.UPDATE_PHYSICAL_PERSON_SUCCESS:
      return {...state, loading: false, error: false};
    case UpdatePhysicalPersonTypes.UPDATE_PHYSICAL_PERSON_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/physical-person/UpdatePhysicalPersonReducer.tsx